import {
  ForceMap,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';
import { AssestmentEvaluationSetting } from './assestment-evaluation-setting';
import { Attention } from './attention.model';
import { ConsentToTreatment } from './consent-to-treatment.v2.model';
import { PLAN_CONST, TypeOfAssessment } from './constants';
import { DEFAULT_CRISIS_PLAN, DEFAULT_CRISIS_PLAN_PREVENTION } from './crisis-plan.v2.model';
import { DeEscalationTechnique } from './de-escalation-technique';
import { DocumentV2 } from './document.v2.model';
import { Escape } from './escape.model';
import { Intervention } from './intervention.v2.model';
import { Medication } from './medication.model';
import { PlanV2 } from './plan.v2.model';
import { PrevalentSettingEventAndAntecedent } from './prevalent-setting-event-and-antecedent';
import { BehaviorAssistantRationaleWorkSchedule } from './behavior-assistant-rationale-work-schedule.model';
import { Recommendation } from './recommendation.model';
import { Sensory } from './sensory.model';
import { Tangible } from './tangible.model';
import { BEHAVIOR_ASSISTANT_RATIONALE, SCHEDULE_OF_SERVICES_BREAKDOWN_DEFAULT } from './constants-with-placeholders';

export interface SchoolServicesJustification {
  medical_necessity_justification?: string;
  addressing_school_setting?: string;
  individualized_treatment_plan?: string;
  supporting_documentation_attached?: string;
}

export interface CrisisPlan {
  description: string;
  prevention: string;
}
export class BipV2 {
  id?: number;
  client_id?: number; //patient_id
  doctor_id?: number;
  documents_reviewed?: DocumentV2[];
  documents_and_result?: string;
  assestment_conducted?: string;
  assestment_evaluation_settings?: AssestmentEvaluationSetting[];
  attention?: Attention[];
  background_information?: string;
  policy?: string;
  caregiver_trainings?: PlanV2[];
  consent_to_treatment?: ConsentToTreatment;
  crisis_plan?: CrisisPlan;
  current_treatment_and_progress?: string;
  de_escalation_techniques?: DeEscalationTechnique[];
  education_status?: string;
  escape?: Escape[];
  generalization_training?: string;
  risk_assessment?: string;
  fading_plan?: string;
  school_fading_plan?: string;
  individualized_rationale?: string;
  discharge_plan?: string;
  comments_recommendations?: string;
  schedule_of_services_recommendations?: string;
  recommendation_period?: number;
  recommendations?: Recommendation[];
  hypothesis_based_intervention?: string;
  behavior_assistant_rationale_introduction?: string;
  behavior_assistant_rationale_work_schedule?: BehaviorAssistantRationaleWorkSchedule;
  schedule_of_services_breakdown?: BehaviorAssistantRationaleWorkSchedule;
  school_services_justification?: SchoolServicesJustification;
  apply_schedule_of_services?: boolean;
  functional_impairment_behavior_concerns?: string;
  interventions?: Intervention[];
  maladaptives?: PlanV2[];
  primary_language_spoken?: string;
  history_trauma?: string;
  comorbidities?: string;
  patient_identifier?: string;
  physical_and_medical?: Medication[];
  physical_and_medical_status?: string;
  prevalent_setting_event_and_antecedents?: PrevalentSettingEventAndAntecedent[];
  previous_treatment_and_result?: string;
  rbt_trainings?: PlanV2[];
  no_need_medication?: boolean;
  report_writer?: string;
  report_writer_2?: string;
  report_writer_id?: number;
  report_writer_2_id?: number;
  replacements?: PlanV2[];
  sensory?: Sensory[];
  strengths?: string;
  tangibles?: Tangible[];
  teacher_trainings?: PlanV2[];
  type_of_assessment?: TypeOfAssessment;
  weaknesses?: string;
  updated_at?: Date;
  created_at?: Date;
  deleted_at?: Date;
  last_date_check?: string;
  service_start_date?: string;

  constructor(data: Partial<BipV2>) {
    const self: BipV2 = {
      ...data,
      id: NumberOrNullOrUndefined(data.id),
      client_id: NumberOrNullOrUndefined(data.client_id),
      type_of_assessment: StringOrNullOrUndefined(
        data.type_of_assessment
      ) as TypeOfAssessment,
      doctor_id: NumberOrNullOrUndefined(data.doctor_id),
      patient_identifier: StringOrNullOrUndefined(data.patient_identifier),

      primary_language_spoken: StringOrNullOrUndefined(data.primary_language_spoken),
      history_trauma: StringOrNullOrUndefined(data.history_trauma),
      comorbidities: StringOrNullOrUndefined(data.comorbidities),

      maladaptives: ForceMap(data.maladaptives ?? [], PlanV2),
      replacements: ForceMap(data.replacements ?? [], PlanV2),
      strengths: StringOrNullOrUndefined(data.strengths),
      weaknesses: StringOrNullOrUndefined(data.weaknesses),
      assestment_evaluation_settings: ForceMap(
        data.assestment_evaluation_settings ?? [],
        AssestmentEvaluationSetting
      ),
      documents_reviewed: ForceMap(data.documents_reviewed ?? [], DocumentV2),
      documents_and_result: StringOrNullOrUndefined(data.documents_and_result),
      assestment_conducted: StringOrNullOrUndefined(data.assestment_conducted),
      background_information: StringOrNullOrUndefined(
        data.background_information
      ),
      policy: StringOrNullOrUndefined(
        data.policy
      ),
      current_treatment_and_progress: StringOrNullOrUndefined(
        data.current_treatment_and_progress
      ),
      education_status: StringOrNullOrUndefined(data.education_status),
      caregiver_trainings: ForceMap(data.caregiver_trainings ?? [], PlanV2),
      teacher_trainings: ForceMap(data.teacher_trainings ?? [], PlanV2),
      hypothesis_based_intervention:
        StringOrNullOrUndefined(data.hypothesis_based_intervention) ??
        PLAN_CONST.HYPOTHESIS_BASED_INTERVENTION,
      behavior_assistant_rationale_introduction:
        StringOrNullOrUndefined(data.behavior_assistant_rationale_introduction) ??
        BEHAVIOR_ASSISTANT_RATIONALE.introduction,
      behavior_assistant_rationale_work_schedule:
        new BehaviorAssistantRationaleWorkSchedule(
          data.behavior_assistant_rationale_work_schedule ??
          BEHAVIOR_ASSISTANT_RATIONALE.work_schedule
      ),
      schedule_of_services_breakdown:
        new BehaviorAssistantRationaleWorkSchedule(
          ((data as unknown as { schedule_of_services_breakdown?: { work_schedule?: BehaviorAssistantRationaleWorkSchedule } }).schedule_of_services_breakdown?.work_schedule ??
(data.schedule_of_services_breakdown as BehaviorAssistantRationaleWorkSchedule)) ??
          SCHEDULE_OF_SERVICES_BREAKDOWN_DEFAULT
      ),
      apply_schedule_of_services: BooleanOrNullOrUndefined((data as { apply_schedule_of_services?: boolean }).apply_schedule_of_services),
      school_services_justification: ((): SchoolServicesJustification | undefined => {
        const ssj = (data as { school_services_justification?: SchoolServicesJustification })
          .school_services_justification;
        if (!ssj) return undefined;
        return {
          medical_necessity_justification: StringOrNullOrUndefined(ssj.medical_necessity_justification),
          addressing_school_setting: StringOrNullOrUndefined(ssj.addressing_school_setting),
          individualized_treatment_plan: StringOrNullOrUndefined(ssj.individualized_treatment_plan),
          supporting_documentation_attached: StringOrNullOrUndefined(ssj.supporting_documentation_attached),
        };
      })(),
      interventions: ForceMap(data.interventions ?? [], Intervention),
      rbt_trainings: ForceMap(data.rbt_trainings ?? [], PlanV2),
      physical_and_medical: ForceMap(data.physical_and_medical ?? [], Medication),
      physical_and_medical_status: StringOrNullOrUndefined(
        data.physical_and_medical_status
      ),
      previous_treatment_and_result: StringOrNullOrUndefined(
        data.previous_treatment_and_result
      ),
      sensory: ForceMap(data.sensory ?? [], Sensory),
      tangibles: ForceMap(data.tangibles ?? [], Tangible),
      attention: ForceMap(data.attention ?? [], Attention),
      escape: ForceMap(data.escape ?? [], Escape),
      de_escalation_techniques: ForceMap(
        data.de_escalation_techniques ?? [],
        DeEscalationTechnique
      ),
      consent_to_treatment: new ConsentToTreatment(data.consent_to_treatment ?? {}),
      generalization_training: StringOrNullOrUndefined(
        data.generalization_training
      ),
      risk_assessment: StringOrNullOrUndefined(data.risk_assessment),
      school_fading_plan: StringOrNullOrUndefined(data.school_fading_plan),
      individualized_rationale: StringOrNullOrUndefined(data.individualized_rationale),
      functional_impairment_behavior_concerns: StringOrNullOrUndefined((data as { functional_impairment_behavior_concerns?: string }).functional_impairment_behavior_concerns),
      report_writer: StringOrNullOrUndefined(data.report_writer),
      report_writer_2: StringOrNullOrUndefined(data.report_writer_2),
      report_writer_id: NumberOrNullOrUndefined(data.report_writer_id),
      report_writer_2_id: NumberOrNullOrUndefined(data.report_writer_2_id),
      fading_plan: StringOrNullOrUndefined(data.fading_plan),
      discharge_plan: StringOrNullOrUndefined(data.discharge_plan),
      no_need_medication: BooleanOrNullOrUndefined((data as { no_need_medication?: boolean }).no_need_medication),
      crisis_plan: data.crisis_plan ? {
        description: (data.crisis_plan as { description?: string }).description || '',
        prevention: (data.crisis_plan as { prevention?: string }).prevention || ''
      } : undefined,
      recommendation_period: NumberOrNullOrUndefined(data.recommendation_period),
      comments_recommendations: StringOrNullOrUndefined(data.comments_recommendations),
      schedule_of_services_recommendations: StringOrNullOrUndefined((data as { schedule_of_services_recommendations?: string }).schedule_of_services_recommendations),
      recommendations: ForceMap(data.recommendations ?? [], Recommendation),
      prevalent_setting_event_and_antecedents: ForceMap(
        data.prevalent_setting_event_and_antecedents ?? [],
        PrevalentSettingEventAndAntecedent
      ),
      last_date_check: StringOrNullOrUndefined(data.last_date_check),
      service_start_date: StringOrNullOrUndefined(data.service_start_date),
    };
    //Extra Changes
    self.maladaptives = (self.maladaptives ?? []).map((item, index) => ({
      ...item,
      index,
    }));
    self.replacements = (self.replacements ?? []).map((item, index) => ({
      ...item,
      index,
    }));
    self.caregiver_trainings = (self.caregiver_trainings ?? []).map((item, index) => ({
      ...item,
      index,
    }));
    self.teacher_trainings = (self.teacher_trainings ?? []).map((item, index) => ({
      ...item,
      index
    }));
    self.rbt_trainings = (self.rbt_trainings ?? []).map((item, index) => ({
      ...item,
      index,
    }));

    return BipV2.addDefaults(self, data);
  }
  static getDefault(): BipV2 {
    return this.addDefaults({
      id: undefined,
      client_id: undefined,
      type_of_assessment: undefined,
      doctor_id: undefined,
      patient_identifier: undefined,
      strengths: undefined,
      weaknesses: undefined,
      assestment_evaluation_settings: [],
      documents_reviewed: [],
      documents_and_result: undefined,
      assestment_conducted: undefined,
      background_information: undefined,
      policy: undefined,
      current_treatment_and_progress: undefined,
      education_status: undefined,
      caregiver_trainings: [],
      teacher_trainings: [],
      hypothesis_based_intervention: undefined,
      behavior_assistant_rationale_introduction: undefined,
      behavior_assistant_rationale_work_schedule: undefined,
      schedule_of_services_breakdown: undefined,
      apply_schedule_of_services: undefined,
      school_services_justification: undefined,
      functional_impairment_behavior_concerns: undefined,
      primary_language_spoken: undefined,
      history_trauma: undefined,
      comorbidities: undefined,
      interventions: [],
      rbt_trainings: [],
      report_writer: undefined,
      report_writer_2: undefined,
      report_writer_id: undefined,
      report_writer_2_id: undefined,
      service_start_date: undefined,
      physical_and_medical: [],
      physical_and_medical_status: undefined,
      previous_treatment_and_result: undefined,
      sensory: undefined,
      tangibles: undefined,
      attention: undefined,
      escape: undefined,
      generalization_training: undefined,
      risk_assessment: undefined,
      fading_plan: undefined,
      school_fading_plan: undefined,
      individualized_rationale: undefined,
      discharge_plan: undefined,
      no_need_medication: false,
      recommendation_period: 6,
      comments_recommendations: undefined,
      schedule_of_services_recommendations: undefined,
      recommendations: [],
      maladaptives: [],
      replacements: [],
      crisis_plan: undefined,
      de_escalation_techniques: [],
      consent_to_treatment: undefined,
      prevalent_setting_event_and_antecedents: [],
      created_at: undefined,
      updated_at: undefined,
      deleted_at: undefined,
      last_date_check: undefined,
    });
  }
  private static addDefaults(
    data: BipV2,
    sourceData?: Partial<BipV2>
  ): BipV2 {
    const isPersistedBip = Number.isFinite(data.id);
    const hasInterventionsArray = Array.isArray(sourceData?.interventions);
    const hasTangiblesArray = Array.isArray(sourceData?.tangibles);
    const hasAttentionArray = Array.isArray(sourceData?.attention);
    const hasEscapeArray = Array.isArray(sourceData?.escape);
    const hasSensoryArray = Array.isArray(sourceData?.sensory);

    data.type_of_assessment ??= '1';
    data.hypothesis_based_intervention ??=
      PLAN_CONST.HYPOTHESIS_BASED_INTERVENTION;
    data.generalization_training ??= PLAN_CONST.GENERALIZATION_TRAINING;
    data.risk_assessment ??= PLAN_CONST.RISK_ASSESSMENT;
    data.fading_plan ??= PLAN_CONST.FADING_PLAN;

    data.discharge_plan ??= PLAN_CONST.DISCHARGE_PLAN;
    data.crisis_plan ??= {
      description: DEFAULT_CRISIS_PLAN,
      prevention: DEFAULT_CRISIS_PLAN_PREVENTION,
    };
  
    data.interventions = data.interventions?.length
      ? data.interventions
      : (isPersistedBip && hasInterventionsArray ? [] : Intervention.getDefaults());
    data.tangibles = data.tangibles?.length
      ? data.tangibles
      : (isPersistedBip && hasTangiblesArray ? [] : Tangible.getDefaults());
    data.attention = data.attention?.length
      ? data.attention
      : (isPersistedBip && hasAttentionArray ? [] : Attention.getDefaults());
    data.escape = data.escape?.length
      ? data.escape
      : (isPersistedBip && hasEscapeArray ? [] : Escape.getDefaults());
    data.sensory = data.sensory?.length
      ? data.sensory
      : (isPersistedBip && hasSensoryArray ? [] : Sensory.getDefaults());
    data.recommendations = data.recommendations?.length
      ? data.recommendations
      : Recommendation.getDefaults();
    data.de_escalation_techniques = data.de_escalation_techniques?.length
      ? data.de_escalation_techniques
      : DeEscalationTechnique.getDefaults();
    data.consent_to_treatment ??= ConsentToTreatment.getDefault();
    return data;
  }
}
